import { Link } from "react-router-dom";
import * as Values from "../static data/selectvalues";
import { useTranslation } from "react-i18next";
export const linkitems =() => {
    return(
        <>            
            <div className="linkitem"> 
                Email : info@lmplatinumestates.cm
            </div>
            <div className="linkitem">
                Appel/WhatsApp : +237 692 85 05 84
            </div>
        </>
    )
}

const archeter = 'Acheter des biens immobiliers qui ont des documents à jour et vérifiés au près des autorités est une étape importante de votre projet. Nous vous garantissons des transactions transparentes, sécurisées et sûres devant le notaire.'
const louer = 'Trouvez dans notre catalogue des bureaux, boutiques, appartements et maisons à louer dans les villes de Yaoundé, Douala et Kribi principalement.'

const CONSTRUIRE = 'Nous réalisons votre maison de rêve, votre projet immobilier à moindre coûts et avec des matériaux haut de gamme. Bâtir sûre et solide est notre priorité ». Finis les bâtiments qui s’écroulent.'

const GESTIONLOCATIVE = 'Vous êtes déjà propriétaire de biens immobiliers et les gérer est un véritable casse-tête pour vous ? Profitez de votre temps libre, nous nous occupons de tout ! Recherche des locataires, rédaction des contrats de location, contrôle des loyers etc..'

const VENDRESONBIENIMMOBILIER
= 'Vous souhaitez vendre votre bien rapidement et au meilleur prix ? Nous vous offrons notre expertise gratuitement pour faire estimer votre bien. Nous vous prodiguons également des conseils pour faire ressortir le potentiel de votre bien afin que le futur acquéreur puisse se projeter facilement. Nous vous aidons à rendre votre bien attractif pour attirer les locataires. Prenez contact avec nos commerciaux sans plus attendre.'
const TOPOGRAPHIE = 'Nos géomètres experts sont compétents pour réaliser vos travaux dans des délais courts avec un taux de satisfaction de 100%. Contactez nos équipes pour votre projet'

export const menuitems=[
    {
        name:"Accueil",
        anchor:"fmshop",
        descr:"",
        link:"/",
        submenu: []
    },{
        name:"Acheter",
        anchor:"fmshop",
        descr: archeter,
        type: Values.offerValues[1],
        submenu: [
            {
            name:"Terrains",
            link:"Terrain"
        },
        {
            name:"Maisons",
            link:"Maison"
        },
        // {
        //     name:"APPARTEMENTS",
        //     link:"Appartement meublé"
        // },
        {
            name:"Autres",
            link:"Autres"
        },
        ]
    },{
        name:"Louer",
        anchor:"fmshop",
        descr: louer,
        type: Values.offerValues[0],
        submenu: [
        {
            name:"Maisons",
            link:"Maison"
        },
        {
            name:"Appartements",
            link:"Appartements"
        },
        {
            name:"Location meublée",
            link:"Meublé"
        },
        {
            name:"Bureau",
            link:"Bureau"
        },
        {
            name:"Boutique",
            link:"Boutique"
        },
        {
            name:"Autres",
            link:"Autres"
        },
        ]
    },{
        name:"Construire",
        anchor:"fmshop",
        descr: CONSTRUIRE,
        submenu: [
        ]
    },{
        name:"Gestion locative",
        anchor:"fmshop",
        descr: GESTIONLOCATIVE,
        submenu: [
        ]
    },{
        name:"Vendre son bien immobilier",
        anchor:"fmshop",
        descr: VENDRESONBIENIMMOBILIER,
        submenu: [
        ]
    },{
        name:"Topographie",
        anchor:"fmshop",
        descr: TOPOGRAPHIE,
        submenu: [
            {
            name:"Bornage",
            link:""
        },
        {
            name:"Terrassement",
            link:""
        },
        {
            name:"Conception et plan topographique",
            link:""
        },
        {
            name:"Urbanisme",
            link:""
        },
        {
            name:"Tirage des plans topographique",
            link:""
        },
        {
            name:"Location de materiel topographique",
            link:""
        },
        {
            name:"Immatriculation",
            link:""
        },
        {
            name:"Lotissement",
            link:""
        },
        {
            name:"Morcellement",
            link:""
        },
        {
            name:"Gestion des litiges",
            link:""
        },
        ]
    },
    ];
